import { render, staticRenderFns } from "./purchase-order.vue?vue&type=template&id=ca684f5e&"
import script from "./purchase-order.vue?vue&type=script&lang=ts&"
export * from "./purchase-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports